import React from "react";
import styled from "styled-components";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { ThemedSpan } from "../../utilities";
import { DateDisplay } from "../../";
import { ClientReportType } from "../../../types/ClientReportType";

const LargePopover = styled(Popover)`
    max-width: 500px;
`;

export type ReportsTableStatusColumnProps = {
    data: ClientReportType,
    getStatusDescription: (v: ClientReportType) => string
};

export const ReportsTableStatusColumm = ({ data, getStatusDescription } : Readonly<ReportsTableStatusColumnProps>) => (
    <OverlayTrigger 
        placement="top"
        overlay={
            <LargePopover>
                <Popover.Header>Status Details</Popover.Header>
                <Popover.Body>
                    <div style={{ textAlign: "left" }}>
                        {/* Report Status */}
                        <>
                            <b>Report Status:</b> {getStatusDescription(data)}
                            <br/>
                        </>
                        {/* Business Sheet Status */}
                        {data.businessSheet && (
                            <>
                                <b>Business Sheet:</b> {data.businessSheet.businessSheetStatusText}
                            </>
                        )}
                    </div>
                </Popover.Body>
            </LargePopover>
        }
    >
        <p className="text-truncate m-0 lh-1">
            {getStatusDescription(data)}
            <br />
            <ThemedSpan variant="muted" className="fs-smallest"><DateDisplay format="DD/MM/YYYY HH:mm">{data.statusDate}</DateDisplay></ThemedSpan>
        </p>
    </OverlayTrigger>
);

export default ReportsTableStatusColumm;